import React from 'react';
import Head from 'next/head';
import { GetServerSidePropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import { API, APIRoutes, BANNER_TARGETS } from '@utils/api';
import MainBanner from '@components/PageBanner';

import Offers from '@components/Offers';
import ImportantSection from '@components/Candidate/ImportantSection';
// import CandidateBanner from '@components/Candidate/CandidateBanner';

function CandidatesPage({ banners, offers }) {
  const { t } = useTranslation('candidate');

  return (
    <>
      <Head>
        <title>{t('page-title')}</title>
      </Head>

      <MainBanner bannerItems={banners} />
      <Offers offers={offers.offers} offersCount={offers.meta.pagination.totalOffers} />
      <ImportantSection />
      {/* <CandidateBanner /> */}
    </>
  );
}

export async function getServerSideProps({ locale }: GetServerSidePropsContext) {
  try {
    const {
      data: { banners },
    } = await API.get(APIRoutes.banners([BANNER_TARGETS.CANDIDATE]));

    const { data: offers } = await API.get(APIRoutes.offers({ pageSize: 6, promoted: true }));

    return {
      props: {
        ...(await serverSideTranslations(locale, [
          'homepage',
          'navbar',
          'footer',
          'offers',
          'common',
          'candidate',
          'newsletter',
        ])),
        banners,
        offers,
      },
    };
  } catch (error) {
    return { props: {} };
  }
}
export default CandidatesPage;
